{
	"split": {
		"logoAlt": "Malaysia 34th SEA Games · 14th ASEAN Para Games 2027",
		"taglineLine1": "Raikan Perpaduan.",
		"taglineLine2": "Celebrating Unity.",
		"welcome": "Welcome to the SEA Games Malaysia 2027 team workspace."
	},
	"login": {
		"title": "Sign in to WSL Notion",
		"subtitle": "The SEA Games team workspace: pages, files, boards and user guides.",
		"identifier": {
			"label": "Username or email",
			"placeholder": "Enter your username or email"
		},
		"password": {
			"label": "Password",
			"placeholder": "Enter your password",
			"show": "Show password",
			"hide": "Hide password"
		},
		"rememberMe": "Remember me on this device",
		"submit": "Sign in",
		"help": "Forgot your password? Ask an administrator to reset it.",
		"notMember": "This account does not hold the Super Admin role. WSL Notion is for super admins only."
	},
	"reasons": {
		"expired": "Your session expired. Please sign in again.",
		"revoked": "Your session was ended. Please sign in again."
	},
	"error": {
		"requestId": "Request ID"
	},
	"validation": {
		"identifierRequired": "Enter your username or email",
		"passwordRequired": "Enter your password",
		"codeRequired": "Enter the 6-digit code",
		"currentPasswordRequired": "Enter your current password",
		"newPasswordMin": "At least 8 characters",
		"newPasswordSame": "New password must be different from the current one",
		"confirmPasswordMismatch": "The passwords do not match"
	},
	"mfa": {
		"backToSignIn": "Back to sign in",
		"verify": {
			"title": "Two-factor code",
			"subtitle": "Signing in as {{name}}. Enter the 6-digit code from your authenticator app.",
			"code": {
				"label": "Authentication code",
				"hint": "A backup code works here too."
			},
			"submit": "Verify"
		},
		"enroll": {
			"title": "Set up two-factor in GMS first",
			"body": "{{name}}, the Super Admin role needs two-factor sign-in and it is not set up yet. Set it up in the Games Management System, then come back and sign in here.",
			"openGms": "Open GMS to set up two-factor"
		}
	},
	"changePassword": {
		"title": "Choose a new password",
		"subtitle": "You signed in with a temporary password. Choose your own password to finish signing in.",
		"titleVoluntary": "Change password",
		"subtitleVoluntary": "Every other session signs out when you do this. This one stays open.",
		"current": "Current password",
		"new": "New password",
		"newHint": "At least 8 characters.",
		"confirm": "Confirm new password",
		"sameAsTemporary": "Choose a password different from your temporary one.",
		"submit": "Save new password",
		"wrongCurrent": "That isn't your current password."
	}
}
